import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import {
  ActivatedRoute,
  NavigationExtras,
  Router,
  UrlHandlingStrategy,
} from "@angular/router";
import { SessionService } from "src/app/services/session.service";
import {
  fetchMFAPreference,
  signOut,
  updateMFAPreference,
} from "aws-amplify/auth";
import { MatDialog } from "@angular/material/dialog";
import { ConstantsService } from "src/app/services/constants.service";
import { DashboardService } from "src/app/services/dashboard.service";
import { DataService } from "src/app/services/data.service";
import { FilterService } from "src/app/services/filter.service";
import { DatePipe, Location } from "@angular/common";
import { NavigationService } from "src/app/services/navigation.service";
import { MatMenuTrigger } from "@angular/material/menu";
import { DeviceDetectionService } from "src/app/services/detectipad.service";
import { MixpanelService } from "src/app/services/mixpanel.service";
import moment from "moment";
import { Subject, Subscription, concatMap, from } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { EnhancementService } from "src/app/services/enhancements-service";
import { DashboardAccessStorageService } from "src/app/services/dashboard-access-storage.service";
import { getStaticDashboardById } from "src/app/components/static-dashboard/static-dashboard.config";
import { AI_USAGE_DASHBOARD_TITLE } from "src/app/components/ai-usage/ai-usage.config";
import { ExportPPTService } from "src/app/services/export-ppt.service";
import { BookmarkService } from "../../shared/bookmark-view/bookmark.service";
import { CommentsNotesService } from "../../shared/comments-notes/comments-notes.service";
import { AlertViewService } from "../../shared/alert-view/alert-view.service";
import { EmailService } from "src/app/services/email-service";
import { result } from "lodash";
import { ConsentFormComponent } from "../../shared/secure-mail/consent-form/consent-form.component";
import { ApiService } from "src/app/services/api.service";
import { DialogService } from "src/app/services/dialog.service";
import { RequestCancelService } from "src/app/services/request-cancel.service";
import { TaskpanelService } from "../../direct/service/taskpanel.service";

declare const bootstrap: any;

@Component({
  selector: "app-topnav",
  templateUrl: "./topnav.component.html",
  styleUrls: ["./topnav.component.scss"],
})
export class TopnavComponent implements OnInit, OnDestroy {
  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;
  @ViewChild("infoMenuTrigger") infoMenuTrigger!: MatMenuTrigger;
  @ViewChild("offcanvasRightAnnotationNotes", { static: false })
  offcanvasRightAnnotationNotes!: ElementRef;

  @Input("logoImage") logoImage = "";
  @Input("prName") prName = "";
  @Input("clientLogo") clientLogo = "";
  logoError = false;
  @Input("title") title = "";
  @Input("pagename") pagename = "";
  @Input("refreshTheDashboard") refreshTheDashboard: any;
  @Input("colorCode") colorCode = "";
  @Input("notesConfiguration") notesConfiguration = "";

  userName: string = "";
  toggleAlert: boolean = false;
  type: string = "linear-gradient";
  logo: any;
  line: any;
  moduleKey: any;
  clientKey: any;
  dashboardKey: any;
  modulePage: boolean = false;
  embedDashboardId = "";
  embedReportId = "";
  embedUsageRoute = false;
  showAlerts: boolean = true;
  refreshPageData = false;
  locationLoaded = true;
  id: any;
  cardName: any = "";
  cardValue: any = "";
  cardId: any;
  locationName: any;
  environment: any;
  decryptedParams: any;
  routerLoader = false;
  isIpad = false;
  userEmail = "";
  clientLength: any = [];
  intervalId: any;
  lastRefreshDate: any;
  selectedBrandName: any;
  accountName: any;
  // Page-level help info, fetched on demand and shown in the #info mat-menu.
  infoData: any;
  patientAwaitingTherapy:any;
  get displayRefreshDate(): string {
    const date = this.moduleKey == 100101 ? this.lastRefreshDate : this.refreshDate;
    return date ? date + ' ET' : 'No Date';
  }
  moduleName: any;
  pdrpRestricted:any;
  usrImp: any;
  userInfo: any;
  gender: any;

  trash = "trash_delete";
  edit = "editIcon";
  cancel_x = "cancel_x";

  userProfile_logout = "userProfile_logout";
  userProfile_bell = "userProfile_bell";
  userProfile_manage = "userProfile_manage";

  refreshData = false;
  refreshDate: any;
  reqSubcription: Subscription[] = [];
  // Debounces rapid schema toggles so only the final selection (after 2s of
  // no further clicks) cancels in-flight requests and re-runs the page queries.
  private schemaChange$ = new Subject<void>();
  data:any={};
  unreadCount:any=0;
  unreadBookmarkTotalCount=0;
  unreadEventCountValue = 0;
  // Flags
  annotationIndication = false;
  alertIndication = false;
  annotationClicked = false;
  alertClicked = false;
  unreadAlertCount = 0;
  alertViewClicked = false;
  CalendarIndication = false;
  CalendarClicked = false;
  mailIndication = false;
  secureMailClicked = false;
  filterFlag = false;
  filterEventFlag = false;
  @Input("widgetHelpInfo") widgetHelpInfo: any;

  get isModuleKeyExcludedNotes(): boolean {
    if (typeof this.moduleKey === "string") {
      this.moduleKey = Number(this.moduleKey);
    }
    return [100109].includes(this.moduleKey);
  }

  get isModuleKeyExcludedAlerts(): boolean {
    if (typeof this.moduleKey === "string") {
      this.moduleKey = Number(this.moduleKey);
    }
    return [100108, 100110, 100114].includes(this.moduleKey);
  }

  taskCount = 10;
  private sub?: Subscription;

  // Schema selection toggle, driven by the page config (key 555555).
  // schemaConfig is the schemaChecks array, e.g. [{ name: "Primary" }, ...].
  @Input("schemaConfig") schemaConfig: any;
  // Currently selected schema value (lowercased name, e.g. "primary").
  schemaType: string = "primary";

  get schemaOptions(): any[] {
    return Array.isArray(this.schemaConfig) ? this.schemaConfig : [];
  }

  // Multi-schema must be enabled for the user (userInformation session flag).
  get isMultiSchemaEnabled(): boolean {
    return this.userInfo?.multi_schema_flg == "Y";
  }

  get showSchemaToggle(): boolean {
    return (
      this.isMultiSchemaEnabled &&
      !!this.dashboardKey &&
      this.schemaOptions.length > 0
    );
  }

  // Normalize an option to the value sent to the backend / stored in session.
  schemaValue(option: any): string {
    return (option?.name || "").toString().trim().toLowerCase();
  }

  // Maps each schema_type (lowercased, e.g. "primary") to its backing
  // `dm_schema` name, fetched from environment.getSchemaData. The schema toggle
  // options come from the designer config; this API tells us which real DM
  // schema each one points at, surfaced as a tooltip on the toggle button.
  schemaMeta: Record<string, string> = {};

  // Tooltip for a schema toggle button — the dm_schema the option resolves to
  // (e.g. hovering "Primary" shows "du_ana_dm_glaukos_epioxa_ref_2"). Empty
  // until the API responds (no tooltip shown).
  schemaTooltip(option: any): string {
    return this.schemaMeta[this.schemaValue(option)] || "";
  }

  // Fetch the primary/secondary → dm_schema mapping for the current
  // dashboard/brand and build `schemaMeta`. Only relevant when the multi-schema
  // toggle is visible. Payload reuses the standard baseQuery (brand_key /
  // dashboard_key / client_key / employee_key).
  private loadSchemaData(obj:any) {
    if (!this.showSchemaToggle) {
      this.schemaMeta = {};
      return;
    }

    let payload:any = { ...(this.filterService.baseQuery || {}) };
    payload['brand_key'] = obj?.brand_key || this.filterService?.baseQuery?.brand_key || undefined; 
    payload['dashboard_key'] = this.dashboardKey; 
    this.reqSubcription.push(
      this.apiService.post(environment.getSchemaData, payload).subscribe({
        next: (res: any) => {
          const rows = Array.isArray(res) ? res : res?.data || [];
          const map: Record<string, string> = {};
          (rows || []).forEach((r: any) => {
            const type = (r?.schema_type || "").toString().trim().toLowerCase();
            if (type) map[type] = (r?.dm_schema || "").toString();
          });
          this.schemaMeta = map;
        },
        error: () => {
          this.schemaMeta = {};
        },
      })
    );
  }

  constructor(
    private dialog: MatDialog,
    private route: Router,
    private router: ActivatedRoute,
    private apiService: ApiService,
    private sessionService: SessionService,
    private dashboardService: DashboardService,
    private dataService: DataService,
    public filterService: FilterService,
    private navigationService: NavigationService,
    private mixpanelService: MixpanelService,
    public deviceDetectionService: DeviceDetectionService,
    public enhancementService: EnhancementService,
    public exportPPT: ExportPPTService,
    public bookmarkService: BookmarkService,
    private commentsNotesService: CommentsNotesService,
    private alertViewService: AlertViewService,
    public emailService: EmailService,
    public elementRef: ElementRef,
    public dialogService: DialogService,
    private sidePanelService: TaskpanelService,
    private cancelService: RequestCancelService,
    private dashboardAccessStorage: DashboardAccessStorageService
  ) {

    // After the user settles on a schema (no further clicks for 2s), cancel any
    // in-flight requests from the previous schema and re-run the page queries.
    this.reqSubcription.push(
      this.schemaChange$.pipe(debounceTime(100)).subscribe(() => {
        this.cancelService.cancelAllRequests();
        setTimeout(() => {
          this.filterService.filterQuery.next(true);
        });
      })
    );

    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe((res: any) => {
        this.filterFlag = true;

        this.unreadAlertCount = 0;
        this.unreadAlert(this.dashboardKey);
        // this.unreadEventCount();

        if (!this.isModuleKeyExcludedNotes) {
          this.unreadCount = 0;
          this.unreadLoadApi(this.dashboardKey);
        }

        this.unreadBookmarkTotalCount = 0;
        this.unreadBookmarkTotalApi(this.dashboardKey);
      })
    );

    this.router.params.subscribe((p: any) => {
      this.cardName = p["cardName"] || "";
      this.moduleName = p["module"] || "";
      this.embedDashboardId = p["dashboardId"] || "";
      this.embedReportId = p["reportId"] || "";
      this.embedUsageRoute = this.route.url.includes("/usage");
      // Query Params
      this.router.queryParams.subscribe((params: any) => {
        this.decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = this.decryptedParams["cl_key"];
        this.moduleKey = this.decryptedParams["md_key"];
        this.dashboardKey = this.decryptedParams["ds_key"];
        this.patientAwaitingTherapy = this.decryptedParams["pwt"] || undefined;

        // Module Or Dashboard
        if (this.embedDashboardId || this.embedReportId || this.embedUsageRoute) {
          this.modulePage = false;
        } else if (this.dashboardKey) {
          this.modulePage = false;
        } else if (
          this.moduleKey == 100113 ||
          this.moduleKey == 100112 ||
          this.moduleKey == 100117 ||
          this.moduleKey == 100118
        ) {
          this.modulePage = false;
        } else {
          this.modulePage = true;
        }

        this.accountName = params["acc_nm"] || "";
        this.pdrpRestricted = params["pdrp"] || "";

        if (params["page"]) {
          this.locationName = "";
        }

        // If Card Name;
        if (this.cardName || this.moduleName == "AI") {
          this.routerLoader = true;
        } else if (this.embedDashboardId) {
          const staticDef = getStaticDashboardById(this.embedDashboardId);
          this.pagename = staticDef?.title || this.pagename;
          this.dashboardService.dashboardName = this.pagename;
          this.routerLoader = true;
        } else if (this.embedReportId) {
          // pagename is supplied by the Power BI embed parent via @Input()
          this.routerLoader = true;
        } else if (this.embedUsageRoute) {
          this.pagename = AI_USAGE_DASHBOARD_TITLE;
          this.dashboardService.dashboardName = this.pagename;
          this.routerLoader = true;
        } else {
          // Read the dashboardAccess data from IndexedDB (keyed by moduleKey)
          // instead of the in-memory allPageInformation subject. Same concept,
          // just sourced from persistent storage.
          this.dashboardAccessStorage
            .getDashboardAccess(this.moduleKey)
            .then((res: any) => {
            const headerName: any = sessionStorage.getItem("navbar_page_nm");
            let pageName: any = JSON.parse(headerName);

            if (res) {
              // Payment Calc Header Name
              if (
                params?.["record"] == "yes" &&
                this.dashboardKey == 20230508080217
              ) {
                this.pagename = "Payment Details";
              } else {
                // TopNav Header Name
                let headerName = res?.find(
                  (o: any) => o.dashboard_key == this.dashboardKey
                );
                if (headerName) {
                  this.pagename =
                    headerName?.dashboard_nm || headerName?.work_nm || "";
                } else {
                  this.pagename = pageName?.dashboard_nm || pageName?.work_nm;
                }
              }
            } else {
              this.pagename = pageName?.dashboard_nm || pageName?.work_nm;
            }

            this.dashboardService.dashboardName = this.pagename;
          });

          this.routerLoader = false;
        }
      });
    });

    this.environment = environment.topAlertSetting;

    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe((r): any => {
        this.lastRefreshDate =
          moment().format("MM/DD/YYYY") + " - " + moment().format("HH:mm");
      })
    );

    let user: any = sessionStorage.getItem("userInformation");
    user = JSON.parse(user);

    this.userAttributes(user);
  }

  async pptExport(): Promise<void> {
    const gridster = document.querySelector("gridster");

    if (!gridster) {
      console.log("Gridster element not found.");
      return;
    }

    const gridsterItems = gridster.querySelectorAll("gridster-item");

    if (gridsterItems.length === 0) {
      console.log("No gridster items found.");
      return;
    }

    const itemsArray = Array.from(gridsterItems);
    itemsArray.pop();

    try {
      await this.exportPPT.exportToPpt(
        itemsArray as HTMLElement[],
        this.pagename
      );
    } catch (error) {
      console.error("Error exporting to PowerPoint:", error);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes["pagename"]?.currentValue != changes["pagename"]?.previousValue
    ) {
      const name = changes["pagename"].currentValue;
      if (name && (this.embedDashboardId || this.embedReportId || this.embedUsageRoute)) {
        this.pagename = name;
        this.dashboardService.dashboardName = name;
      }
      document.title = name ? `SCRAII - ${name}` : "SCRAII";
    }

    if (changes["schemaConfig"]) {
      this.initSchemaSelection();
    }
  }

  // New MFA Setup
  setupMethod: string = "TOTP";
  defaultSetupMethod: any;
  isMfaOpen = false;
  toggleMfa(event: Event) {
    event.stopPropagation(); // keep dropdown open
    this.isMfaOpen = !this.isMfaOpen; // toggle collapse
  }

  ngOnInit(): void {
    // New MFA Setup
    let mfaMethod: any = sessionStorage.getItem("mfaMethod");
    mfaMethod = JSON.parse(mfaMethod);
    this.setupMethod = mfaMethod?.["_value"] == "TOTP" ? "TOTP" : "EMAIL";
    this.defaultSetupMethod = this.setupMethod;

    setTimeout(() => {
      this.filterFlag = true;
    }, 25000);

    this.data["width"] = 320;

    this.lastRefreshDate =
      moment().format("MM/DD/YYYY") + " - " + moment().format("HH:mm");

    this.reqSubcription.push(
      this.filterService.lastRefreshedDate.subscribe((r: any) => {
        if (r) {
          this.selectedBrandName = r["brand_name"] || "";
          this.refreshLastDate(r);
        }

        // baseQuery (incl. brand_key) is ready by the time filterQuery fires,
        // so fetch the schema_type → dm_schema mapping for the toggle tooltips
        // here rather than on schemaConfig change (which runs before a brand is
        // resolved). No-op unless the multi-schema toggle is visible.
        this.loadSchemaData(r);

      })
    );

    this.reqSubcription.push(
      this.filterService.topNavLocation.subscribe((r: any) => {
        // debugger
        if (this.patientAwaitingTherapy && this.accountName) {
          this.locationName = r["account_name"] || this.locationName;
        }
      })
    );

    // Environment get from session
    let switchClient: any = sessionStorage.getItem("switchClient");
    this.clientLength = switchClient ? JSON.parse(switchClient) : [];

    this.userEmail = this.sessionService.getMainUsername();
  }

  // Restore the user's remembered schema choice when the page config arrives or
  // the tab changes, falling back to the first option if it is no longer valid.
  // When the page/tab has no schema checks, clear the sent value (but keep the
  // remembered selection) so schema_type is not sent in any request.
  private initSchemaSelection() {
    const options = this.schemaOptions;
    if (!this.isMultiSchemaEnabled || !options.length) {
      this.schemaType = "";
      sessionStorage.removeItem("schema_type");
      return;
    }

    const values = options.map((o: any) => this.schemaValue(o));
    const saved = sessionStorage.getItem("schema_type_selection");
    this.schemaType = saved && values.includes(saved) ? saved : values[0];

    sessionStorage.setItem("schema_type", this.schemaType);
    sessionStorage.setItem("schema_type_selection", this.schemaType);
  }

  // Switch the active schema, remember the choice, and re-run the page queries.
  onSchemaChange(option: any) {
    const value = this.schemaValue(option);
    if (this.schemaType === value) return;
    this.schemaType = value;
    sessionStorage.setItem("schema_type", value);
    sessionStorage.setItem("schema_type_selection", value);
    // Update the selection (above) immediately so the toggle reflects the
    // click, but debounce the actual re-run by 2s. Rapid clicks reset the
    // timer; only the final selection cancels in-flight requests (via the
    // takeUntil in MyInterceptor) and re-runs the page queries.
    this.schemaChange$.next();
  }
  styleLogo(styleLogo: any) {
    return styleLogo;
  }

  logoclicktoBack() {
    this.filterService.brandSelectWithBackNavigation = true;
    if (this.moduleKey) {
      let query = {
        cl_key: this.clientKey,
        md_key: this.moduleKey,
      };

      this.navigationService.routerNavigate(
        `dashboard/${this.moduleName}`,
        query
      );
    } else {
      this.route.navigate([`dashboard/`]);
    }
  }

  styleObject(title: any) {
    return { "background-image": "url(" + title + ")" };
  }

  previousPage() {
    if (this.embedDashboardId || this.embedReportId || this.embedUsageRoute) {
      const query: Record<string, string> = {};
      if (this.clientKey) {
        query["cl_key"] = this.clientKey;
      }
      if (this.moduleKey) {
        query["md_key"] = this.moduleKey;
      }
      this.navigationService.routerNavigate(`dashboard/${this.moduleName}`, query);
      return;
    }

    this.navigationService.goBack();
  }

  onChange(event: any) {
    if (event.target.value === "logout") {
      this.logout();
    }
  }

  async updatePreference() {
    try {
      if (this.setupMethod === "TOTP") {
        // Check if TOTP is enabled before setting as preferred
        const mfaPref: any = await fetchMFAPreference();

        if (mfaPref.enabled && mfaPref.enabled.includes("TOTP")) {
          await updateMFAPreference({ totp: "PREFERRED" });
          this.redirectToSnackBar(
            "Your MFA preference has been updated to Authenticator. You will now be redirected to the login page to sign in using your preferred MFA method."
          );
          setTimeout(() => {
            signOut();
            window.location.href = "/login";
          }, 4000);
        } else {
          this.redirectToSnackBar(
            "Authenticator MFA is not enabled for your account. Please complete setup first."
          );
          setTimeout(() => {
            const navigationExtras: NavigationExtras = {
              queryParams: { key: "mfaPreference" },
              replaceUrl: true,
            };
            this.route.navigate(["/login"], navigationExtras);
          }, 4000);
        }
      } else if (this.setupMethod === "EMAIL") {
        // EMAIL is usually always available
        await updateMFAPreference({ email: "PREFERRED" });

        this.redirectToSnackBar(
          "Your MFA preference has been updated to Email. You will now be redirected to the login page to sign in using your preferred MFA method."
        );

        setTimeout(() => {
          signOut();
          window.location.href = "/login";
        }, 4000);
      }
    } catch (err: any) {
      this.redirectToSnackBar(
        err?.message || "Failed to update MFA preference."
      );
    }
  }

  redirectToSnackBar(message: any) {
    this.dialogService.SnackBar(message, "");
  }

  async logout() {
    const userEmail = this.sessionService.getMainUsername();

    const userActivite: any = {
      user_id: userEmail,
      event_name: "Logout",
    };

    try {
      // 1️⃣ Get Local IP (LAN or Intranet)
      userActivite.ip_address = await this.getLocalIP().catch(
        () => "Unavailable"
      );

      // 2️⃣ Get Geolocation from Browser (if allowed)
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (pos) => {
            const { latitude, longitude } = pos.coords;
            userActivite.latitude = latitude;
            userActivite.longitude = longitude;

            // 3️⃣ Reverse-geocode coordinates → location details
            try {
              const geo: any = await fetch(
                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
              ).then((res) => res.json());

              userActivite.location_name = geo.display_name || "Unknown";
              userActivite.city =
                geo.address?.city ||
                geo.address?.town ||
                geo.address?.village ||
                "Unknown";
              userActivite.state = geo.address?.state || "Unknown";
              userActivite.country = geo.address?.country || "Unknown";
            } catch (geoErr) {
              console.warn("Reverse geocode failed", geoErr);
            }

            // 🚀 Send data
            this.sendLogoutActivity(userActivite);
          },
          async (geoError) => {
            console.warn("Geolocation denied", geoError);

            // 🌍 Fallback: Use IP-based lookup if location is blocked
            const ipData: any = await this.getIPInfo();
            Object.assign(userActivite, ipData);

            this.sendLogoutActivity(userActivite);
          }
        );
      } else {
        // ❌ No geolocation support — fallback
        const ipData: any = await this.getIPInfo();
        Object.assign(userActivite, ipData);
        this.sendLogoutActivity(userActivite);
      }
    } catch (error) {
      console.error("Error in logout location fetch:", error);
      this.sendLogoutActivity(userActivite);
    }
  }

  /** 🔄 Send logout details to backend and finalize logout */
  private sendLogoutActivity(data: any): void {
    this.apiService.userActivity(data).subscribe(
      () => {
        console.log("✅ User logout activity logged:", data);
        this.finalLogout();
      },
      (error: any) => {
        console.error("❌ Error logging logout activity", error);
        this.finalLogout();
      }
    );
  }

  /** 🌍 Fallback IP-based location lookup */
  private async getIPInfo(): Promise<any> {
    try {
      const res = await fetch("https://ipapi.co/json/");
      const data = await res.json();
      return {
        ip_address: data.ip,
        latitude: data.latitude,
        longitude: data.longitude,
        location_name: `${data.city}, ${data.region}, ${data.country_name}`,
        city: data.city,
        state: data.region,
        country: data.country_name,
      };
    } catch (e) {
      console.warn("IP-based location failed", e);
      return {};
    }
  }

  /** 💻 Get local IP (works on intranet / LAN) */
  private getLocalIP(): Promise<string> {
    return new Promise((resolve, reject) => {
      const pc = new RTCPeerConnection({ iceServers: [] });
      pc.createDataChannel("");
      pc.createOffer()
        .then((offer) => pc.setLocalDescription(offer))
        .catch(reject);

      pc.onicecandidate = (event) => {
        if (!event || !event.candidate) return;
        const candidate = event.candidate.candidate;
        const ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3})/;
        const ipMatch = ipRegex.exec(candidate);
        if (ipMatch) {
          resolve(ipMatch[1]);
          pc.close();
        }
      };

      // Timeout fallback
      setTimeout(() => reject("Timeout"), 3000);
    });
  }

  finalLogout() {
    signOut();
    sessionStorage.clear();
    this.mixpanelService.track("Logout");
    this.dialog.closeAll();
    this.sessionService.setUser(null);
    this.sessionService.setUsername(null);
    this.sessionService.setMainUsername(null);
    this.sessionService.setLoginTime(null);

    // Clear history and navigate to login page
    // const navigationExtras: NavigationExtras = {
    //   queryParams: { key: "mfaPreference" },
    //   replaceUrl: true
    // };
    // this.route.navigate(['/login'], navigationExtras);
    window.location.href = "login";
  }

  userAttributes(res: any) {
    let userImper: any = sessionStorage.getItem("userImperson");
    this.usrImp = JSON.parse(userImper);

    if (res) {
      this.userInfo = res ? res : {};
      this.userName = res.usr_display_nm;
      this.sessionService.userName = res.usr_display_nm;
      this.gender = res.gender || "M";
    }
  }

  impersonation() {
    window.location.href = "/impersonation";
  }

  toggleAlertSettings() {
    this.toggleAlert = true;
    this.dataService.alertSettingToggle.next(true);
  }
  showNotifications() {
    this.showAlerts = false;
  }

  closeMenu() {
    this.trigger.closeMenu();
  }

  closeInfoMenu() {
    this.infoMenuTrigger?.closeMenu();
  }

  // Fetch the page-level help text (and any embedded user-manual link) and show
  // it in the #info mat-menu. Mirrors the chart-level help in icon-chart, but
  // keyed at the page level (page_key / dashboard_key) instead of per-widget.
  getInfoDetail() {
    let data: any = {
      page_key: this.filterService?.pageKey,
      dashboard_key: this.dashboardKey,
      report_typ: "D",
      brand_key: null,
      api_key: null,
      widget_key: null,
      file_nm: this.widgetHelpInfo?.pageInfoVar || '' 
    };

    this.dataService.getInfoDetail(data).subscribe((res: any) => {
      this.infoData = res?.[0] || { info_header: "No Info Data Found", info_text: "No Info Text Available" };
      // Resolve the user-manual placeholder (??um_url) to the export URL.
        if(data["file_nm"]) {
          // Fetch the export URL for the user manual
          this.dataService.getExportUserManual(data).subscribe((url: any) => {
            if (url) {
              this.infoData["info_text"] = this.replacePlaceholder(this.infoData.info_text, url);
            } else {
              this.handleUserManualError(this.infoData);
            }
          },
            (err: any) => {
              if (err.status === 200) {
                this.infoData["info_text"] = this.replacePlaceholder(this.infoData.info_text, err.error.text);
              } else {
                this.handleUserManualError(this.infoData);
              }
            }
          );
        }
      },
      () => {
        this.infoData = {
          info_header: "No Info Data Found",
          info_text: "Unable to fetch info text.",
        };
      }
    );
  }

  private replacePlaceholder(text: string, url: string): string {
    return (text || "").replace("??um_url", url);
  }

  private handleUserManualError(infoData: any): void {
    this.infoData["info_text"] = infoData.info_text.replace("??um_url", "??um_url");
  }

  getRefreshData() {
    this.refreshPageData = true;
    this.filterService.filterQuery.next(true);
    this.lastRefreshDate =
      moment().format("MM/DD/YYYY") + " - " + moment().format("HH:mm");
    setTimeout(() => {
      this.refreshPageData = false;
    }, 2000);
  }

  menuBar() {
    this.filterService.userMenuSideBar.next(true);
  }

  switchClient() {
    sessionStorage.removeItem("client");
    this.route.navigate([`home/`]);
  }

  refreshLastDate(brand: any) {
    if (brand) {
      let obj = {
        brand_key: brand.brand_key,
        dashboard_key: this.dashboardKey || "",
        module_key: this.moduleKey,
      };
      this.reqSubcription.push(
        this.dashboardService
          .getRefreshedLastDate(obj)
          .subscribe((res: any) => {
            this.filterService.refreshData = true;
            if (res) {
              this.refreshDate = res[0]
                ? moment(res[0].refresh_date).format("MM/DD/YYYY") +
                  " - " +
                  moment(res[0].refresh_date).format("HH:mm")
                : "";
            }
          })
      );
    }
  }

  openAlertsPopupDQ() {
    let query = {
      tab_id: 0,
      cl_key: this.clientKey,
      md_key: this.moduleKey,
      ds_key: "20231130022815",
    };

    let dashboardDetail = {
      dashboard_nm: "Alerts",
      work_nm: "Alerts",
      dashboard_key: "20231130022815",
    };
    sessionStorage.setItem("navbar_page_nm", JSON.stringify(dashboardDetail));
    this.navigationService.routerNavigate(
      `dashboard/${"Operations"}/page/alert/config`,
      query
    );
  }

  onResizeSideWindow(event: any) {
    this.data = event;
  }

  // Detect clicks outside the offcanvas
  // @HostListener('document:click', ['$event'])
  // onOutsideClick(event: MouseEvent): void {
  //   const clickedInside = this.offcanvasRightAnnotationNotes.nativeElement.contains(event.target as Node);
  //   const isToggleButton = (event.target as HTMLElement).classList.contains('offcanvas-toggle-button');

  //   // Only close if the click is outside the offcanvas and not on the toggle button
  //   if (!clickedInside && !isToggleButton) {
  //     this.closeOffcanvas();
  //   }
  // }

  // // Method to close the offcanvas
  // closeOffcanvas(): void {
  //   const offcanvasElement = document.getElementById('offcanvasRightAnnotationNotes');
  //   const bootstrapOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement!);

  //   if (bootstrapOffcanvas) {
  //     bootstrapOffcanvas.hide();
  //   }
  // }

  loadMailView() {
    this.mailIndication = !this.mailIndication;
    this.secureMailClicked = true;

    const offcanvasElement = this.elementRef.nativeElement.querySelector(
      "#offcanvasRightMailView"
    );
    if (offcanvasElement) {
      // Initialize the offcanvas and show it
      const offcanvas = new bootstrap.Offcanvas(offcanvasElement);
      offcanvas.show();
    }
  }

  loadAnnotation() {
    this.annotationIndication = !this.annotationIndication;
    this.annotationClicked = true;
  }

  loadAlertView() {
    this.alertIndication = !this.alertIndication;
    this.alertClicked = true;
    this.alertViewClicked = true;
  }

  unreadBookmarkTotalApi(dashboardKey: any) {
    let postdata: any = {
      report_typ: "C",
      module_key: this.dashboardService.moduleKey,
      dashboard_key: dashboardKey,
      brand_key: this.filterService?.baseQuery?.brand_key,
    };

    this.reqSubcription.push(
      this.bookmarkService.unreadTotalBookmarkApi(postdata).subscribe(
        (res: any) => {
          this.unreadBookmarkTotalCount = res?.[0]?.new_items_count || 0;
        },
        (err: any) => {
          this.unreadBookmarkTotalCount = 0;
        }
      )
    );
  }
  
  unreadEventCount() {
    let postData: any = {
    "api_key": 100162,
    "report_typ": "C"
    };
    this.apiService.post("kpi/get-execution-details",postData).subscribe((res: any) => {
      this.unreadEventCountValue = res?.[0]?.unread_event_count || 0;
      this.filterEventFlag = true;
    }, err => {
      this.unreadEventCountValue = 0;
      this.filterEventFlag = true;
    });
  }

  bookmarkClicked = false;
  bookmarkIndication = false;

  loadbookMarkView() {
    this.bookmarkIndication = !this.bookmarkIndication;
    this.bookmarkClicked = true;
  }
  loadCalendarView() {
    this.CalendarIndication = !this.CalendarIndication;
    this.CalendarClicked = true;
  }

  unreadLoadApi(dashboardKey: any) {
    let postdata: any = {
      report_typ: "C",
      module_key: this.dashboardService.moduleKey,
      dashboard_key: dashboardKey,
      brand_key: this.filterService?.baseQuery?.brand_key,
    };

    this.reqSubcription.push(
      this.commentsNotesService.notesQuery(postdata).subscribe(
        (res: any) => {
          this.unreadCount = res?.[0]?.unread_notes || 0;
        },
        (err: any) => {
          this.unreadCount = 0;
        }
      )
    );
  }

  unreadAlert(dashboardKey: any) {
    // debugger
    let postdata: any = {
      report_typ: "C",
      module_key: this.dashboardService.moduleKey,
      dashboard_key: dashboardKey,
      brand_key: this.filterService?.baseQuery?.brand_key,
    };

    this.reqSubcription.push(
      this.alertViewService.alertsQuery(postdata).subscribe(
        (res: any) => {
          this.unreadAlertCount = res?.[0]?.unread_alert_count || 0;
        },
        (err: any) => {
          this.unreadAlertCount = 0;
        }
      )
    );
  }
  openConsentForm(): void {
    // Check if the policy is already agreed in session storage
    const isPolicyAgreed = JSON.parse(
      sessionStorage.getItem("isPrivacyAgreed") || "false"
    );

    if (isPolicyAgreed) {
      // If policy is already agreed → login first, then load mail view
      this.emailService.login().subscribe({
        next: (result) => {
          if (result === "success") {
            this.emailService.isLogged = true;
            this.loadMailView();
          }
        },
        error: (err) => {
          console.error("Login failed:", err);
        },
      });
      return;
    }

    // Show the consent form if the policy is not agreed
    const dialogRef: any = this.dialog.open(ConsentFormComponent, {
      width: "40%",
      disableClose: false,
      panelClass: "du-custom-modalbox",
      data: "comment",
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((value: any) => {
      if (value) {
        // Store the agreement in session storage
        sessionStorage.setItem("isPrivacyAgreed", JSON.stringify(true));

        // Perform Graph API login, then load mail view only after success
        this.emailService.login().subscribe({
          next: (result) => {
            if (result === "success") {
              this.emailService.isLogged = true;
              this.loadMailView();
            }
          },
          error: (err) => {
            console.error("Login failed:", err);
          },
        });
      }
    });
  }

  // openMailoutlook(){
  // this.emailService.login();
  // this.emailService
  //   .sendEmail('usha.moosapeta@dataunveil.com', 'Test Subject', 'This is the mail body.')
  //   .then(() => alert('Email sent successfully!'))
  //   .catch((error) => alert('Failed to send email: ' + error.message));
  // }

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
    clearInterval(this.intervalId); // Clear the interval when the component is destroyed
  }

  openSidePanel() {
    this.sidePanelService.open();
  }
}
